import React from 'react';
import { RolesListPage } from './list';

export const RolesModule = () => {
  return <RolesListPage />;
};
